type KeyType = "guesses" | "time"

export default class Cache {
  constructor(private readonly prefix: string) {}

  /**
   * Deletes old records
   */
  private purgeHistory(seed: string): void {
    for (let i: number = 0, l: number = localStorage.length; i < l; i++) {
      const k: string | null = localStorage.key(i)
      if (
        k === null ||
        k.startsWith(`${this.prefix}/${seed}`) ||
        !k.startsWith(this.prefix)
      ) {
        // skip anything that's the current seed or not prefixed with this app's prefix.
        continue
      }

      localStorage.removeItem(k)
    }
  }

  private key(seed: string, type: KeyType, base: number = 10): string {
    return `${this.prefix}/${seed}/${base}/${type}`
  }
}
